(function() {
  const BaseDrawer = typeof Drawer !== 'undefined' ? Drawer : HTMLElement;

  class LabDrawer extends BaseDrawer {
    constructor() {
      super();

      if (this.hasAttribute('data-move-to-body') || this.parentElement !== document.body) {
        this.moveOutsideSection();
      }

      this.tabs = this.querySelectorAll('[data-pdp-lab-tab]');
      this.panels = this.querySelectorAll('[data-pdp-lab-panel]');

      this.initTabs();
    }

    moveOutsideSection() {
      if (this.parentElement === document.body) return;

      const overlay = this.nextElementSibling && this.nextElementSibling.classList.contains('overlay')
        ? this.nextElementSibling
        : null;

      const existingDrawer = document.body.querySelector(`:scope > #${this.id}`);
      if (existingDrawer && existingDrawer !== this) {
        const existingOverlay = existingDrawer.nextElementSibling && existingDrawer.nextElementSibling.classList.contains('overlay')
          ? existingDrawer.nextElementSibling
          : null;
        existingDrawer.remove();
        if (existingOverlay) existingOverlay.remove();
      }

      document.body.appendChild(this);
      if (overlay) {
        document.body.appendChild(overlay);
      }
    }

    initTabs() {
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          this.switchTab(tab);
        });

        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const tabArray = Array.from(this.tabs);
            const currentIndex = tabArray.indexOf(tab);
            const nextIndex = e.key === 'ArrowRight'
              ? (currentIndex + 1) % tabArray.length
              : (currentIndex - 1 + tabArray.length) % tabArray.length;

            tabArray[nextIndex].focus();
            this.switchTab(tabArray[nextIndex]);
          }
        });
      });
    }

    switchTab(selectedTab) {
      const targetCategory = selectedTab.dataset.targetTab;

      this.tabs.forEach((tab) => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        if (isSelected) {
          tab.classList.add('is-active', 'button-primary');
          tab.classList.remove('button-outline');
        } else {
          tab.classList.remove('is-active', 'button-primary');
          tab.classList.add('button-outline');
        }
      });

      let activeCoaUrl = '';
      this.panels.forEach((panel) => {
        if (panel.dataset.tabCategory === targetCategory) {
          panel.classList.add('is-active');
          panel.removeAttribute('hidden');
          activeCoaUrl = panel.dataset.coaUrl || '';
        } else {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', '');
        }
      });

      const ctaBtn = this.querySelector('[data-lab-drawer-cta]');
      if (ctaBtn) {
        if (activeCoaUrl) {
          ctaBtn.setAttribute('href', activeCoaUrl);
          ctaBtn.dataset.category = targetCategory;
          ctaBtn.removeAttribute('disabled');
          ctaBtn.style.pointerEvents = 'auto';
          ctaBtn.style.opacity = '1';
        } else {
          ctaBtn.setAttribute('href', '#');
          ctaBtn.setAttribute('disabled', 'disabled');
          ctaBtn.style.pointerEvents = 'none';
          ctaBtn.style.opacity = '0.5';
        }
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'pdp_lab_tab_switch',
          category: targetCategory,
          product_title: this.dataset.productTitle || ''
        });
      }

      if (window.triplePixel) {
        window.triplePixel('pdp_lab_tab_switch', {
          category: targetCategory,
          product_title: this.dataset.productTitle || ''
        });
      }
    }
  }

  if (!window.customElements.get('lab-drawer')) {
    customElements.define('lab-drawer', LabDrawer);
  }

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('[data-pdp-lab-trigger]');
    if (trigger) {
      e.preventDefault();
      const drawerId = trigger.getAttribute('drawer-id') || trigger.getAttribute('aria-controls');
      const drawer = document.getElementById(drawerId);
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(trigger);
      } else if (drawer) {
        drawer.classList.remove('!hidden');
        drawer.classList.add('open');
        const overlay = drawer.nextElementSibling;
        if (overlay && overlay.classList.contains('overlay')) {
          overlay.style.opacity = '1';
        }
      }

      const productTitle = drawer?.dataset.productTitle || '';
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'pdp_lab_badge_open',
          product_title: productTitle
        });
      }
      if (window.triplePixel) {
        window.triplePixel('pdp_lab_badge_open', {
          product_title: productTitle
        });
      }
    }

    const coaLink = e.target.closest('[data-coa-link]');
    if (coaLink) {
      const category = coaLink.dataset.category || '';
      const drawer = coaLink.closest('lab-drawer');
      const productTitle = drawer?.dataset.productTitle || '';
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'pdp_lab_coa_click',
          category: category,
          product_title: productTitle,
          pdf_url: coaLink.getAttribute('href') || ''
        });
      }
      if (window.triplePixel) {
        window.triplePixel('pdp_lab_coa_click', {
          category: category,
          product_title: productTitle
        });
      }
    }
  });
})();
